<template>
    <b-container class="contact" fluid>
        <b-row>
            <b-col class="module">
                <ModuleTitle class="page-title" :caption="contact.title"></ModuleTitle>
            </b-col>
        </b-row>
        <b-row class="list-item">
            <b-col v-for="(item, itemIndex) in contact.items" :key="itemIndex" class="col" cols="6">
                <b-card :title="item.name">
                    <b-card-text v-for="(text, textIndex) in item.desc" :key="textIndex">
                        <div v-html="text"></div>
                    </b-card-text>

                    <div class="images">
                        <div v-for="(img, imgIndex) in item.images" :key="imgIndex" class="imag-item">
                            <div>
                                <img :src="img.imgSrc">
                            </div>
                            <p v-html="img.title"></p>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import ModuleTitle from '../components/common/ModuleTitle'

    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'contact',
        components: {
            ModuleTitle,
        },
        computed: {
            ...mapState('contact', {
                contact: ({contact}) => {
                    return {
                        title: contact.title,
                        items: contact.contact_infos.map((info) => {
                            return {
                                name: info.title,
                                desc: [info.description],
                                images: info.qr_codes && info.qr_codes.map(qrcode => {
                                    return {
                                        imgSrc: qrcode.qr_code_pic_url,
                                        title: qrcode.qr_text,
                                        //subTitle: '官方微博'
                                    }
                                })
                            }
                        })
                    }
                },

            })
        },
        methods: {
            ...mapActions('contact', ['getPageInfo'])
        },
        created() {
            this.getPageInfo()
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/style/var";

    .en {
        .contact {
            .card {
                .card-body {
                    .card-title {
                        font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
                    }

                    .card-text {
                        p {
                            min-height: 84px !important;
                        }
                    }
                }
            }
        }
    }

    .contact {
        padding: 0 150px;

        .list-item {
            .col {
                &:first-child{
                    padding-right: 60px;
                }
                &:nth-child(2){
                    padding-left: 60px;
                }

                &:nth-child(n+3) {
                    margin-top: 100px;
                }
            }
        }

        .module {
            text-align: left;

            /deep/ .title {
                padding-top: 192px !important;
                padding-bottom: 102px !important;
            }
        }

        /deep/ .card {
            border: none;

            .card-body {
                padding: 0;
                text-align: left;

                .card-title {
                    margin-bottom: 20px;
                    font-size: 20px;
                    line-height: 28px;
                    font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif !important;
                }

                .card-text {
                    font-size: 14px;
                    line-height: 28px;
                    margin-bottom: 0 !important;

                    div {
                        p {
                            min-height: 56px;
                            a {
                                text-decoration:none;
                                color: #000;
                            }
                        }
                    }
                }
            }
        }
    }

    .images {
        display: flex;
        margin-top: 50px;
        //justify-content: space-between;

        .imag-item {
            &:nth-child(n+2) {
                margin-left: 130px;
            }

            img {
                width: 120px;
                margin-bottom: 15px;
            }

            p {
                font-size: 12px;
                line-height: 20px;
                margin: 0;
                text-align: center;
            }
        }
    }
</style>
